////////////////////
// Template

import { format_price } from "../../utils/cart-utils";

const IMAGE_WIDTH = 114;
const IMAGE_HEIGHT = 114;

////////////////////
const template = /*html*/ `
    <li class='c-cart-item'>
        <div class="c-cart-item_description">
            <figure class="c-figure c-cart-item_visual">
                <div class="c-figure_inner || c-lazy">
                    <img
                        class="c-figure_image || c-lazy_image -lazy-loaded"
                        :src="image | imageUrl"
                        :alt="title"
                        width="200"
                        height="200"
                        loading="eager"
                    >
                </div>
            </figure>
            <div class="c-cart-item_content">
                <div class="c-cart-item_content_top">
                    <h3 class="c-text -small">{{ title }}</h3>
                    <p v-if="currentOptions" class="c-cart-item_options || c-text">{{ currentOptions }}</p>
                    <p class="c-cart-item_options" v-if="currentTokenGatedDiscount && hasTokenGatedProducts">{{ currentTokenGatedDiscount }} (Applied at Checkout)</p>
                </div>
                <div class="c-cart-item_content_bottom">
                    <div class="c-cart-item_form">
                        <quantity-input
                            ref="quantityInput"
                            class="-cart"
                            :default-value="quantity"
                            :max="inventoryQuantity"
                            :force-default-value="true"
                            @onIncrease="onIncreaseQuantity"
                            @onDecrease="onDecreaseQuantity"
                            @onDelete="onDeleteItem"
                        />
                        <button class="c-cart-item_delete || c-text" aria-label="Remove" type="button" @click="onDeleteItem" v-if="!hasTokenGatedProducts">
                            <span class="c-button_label">{{ deleteLabel }}</span>
                        </button>
                    </div>
                    <p class="c-cart-item_price">
                        <span v-if="currentOriginalPrice" class="c-cart-item_price_original || c-text">{{ currentOriginalPrice }}</span>
                        <span class="c-cart-item_price_current || c-text">{{ currentPrice }}</span>
                    </p>
                </div>
            </div>
        </div>
    </li>
`;


////////////////////
// Scripts
////////////////////
const THUMBNAIL_WIDTH = 200;

export default function VueCartItem() {

    Vue.component("cart-item", {

        template,

        props: {
            variantId: {
                type: String,
                required: true
            },
            quantity: {
                type: Number,
                required: true
            },
            inventoryQuantity: {
                type: Number,
                required: false
            },
            price: {
                type: Object,
                default: () => {}
            },
            compareAtPrice: {
                type: Object,
                default: () => {}
            },
            product: {
                type: Object,
                default: () => {}
            },
            image: {
                type: String,
                required: true
            },
            selectedOptions: {
                type: Object,
                default: () => {}
            },
            moduleInstance: {
                type: Object,
                default: () => {}
            },
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            deleteLabel: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            cartKey: {
                type: String,
                required: true
            },
            hasTokenGatedProducts: {
                type: Boolean,
                default: false
            },
            properties: {
                type: Object,
                default: () => {}
            }
        },

        data() {
            return {
                currentImageObj: {}
            };
        },

        computed: {
            currentPrice() {
                return format_price((parseFloat(this.price, 10)), this.currencySymbol, this.currencyIsoCode, window.isoCode)
            },
            currentOriginalPrice() {
                return this.compareAtPrice && this.compareAtPrice ? format_price((parseFloat(this.compareAtPrice, 10)), this.currencySymbol, this.currencyIsoCode, window.isoCode) : ''
            },
            currentSale() {
                return this.compareAtPrice && this.compareAtPrice ? `-${100 - Math.round(this.price / this.compareAtPrice * 100)}%` : ''
            },
            currentOptions() {
                const options = this.selectedOptions.map((options) => {
                    return options.value.charAt(0).toUpperCase() + options.value.slice(1)
                })

                if ( options.length === 1 && options[0] != "Default Title") {
                    return options[0]
                } else if (options.length && options.length > 1) {
                    return options.join(' / ')
                } else {
                    return ''
                }
            },
            currentTokenGatedDiscount() {
                return this.properties && this.properties["Discount (Applied at Checkout)"]
            }
        },

        mounted() {

        },

        methods: {
            onDeleteItem() {
                this.moduleInstance?.removeItem(this.cartKey)
            },

            onIncreaseQuantity() {
                this.moduleInstance?.updateCartItem({
                    productGID: this.variantId,
                    quantity: this.quantity + 1
                })
            },

            onDecreaseQuantity() {
                this.moduleInstance?.updateCartItem({
                    productGID: this.variantId,
                    quantity: this.quantity - 1
                })
            }
        },
        filters: {
            imageUrl: function(value) {
                if (typeof value != "string") return value;
                return `${value}&width=${THUMBNAIL_WIDTH}&height=${THUMBNAIL_WIDTH}&crop=center`;
            },
        },
    });
}
